import FAQPage from "../../../../src/components/faq-page";
import * as React from 'react';
export default {
  FAQPage,
  React
};